// extracted by mini-css-extract-plugin
module.exports = {"boxVertical":"styles_boxVertical__3kht5","boxHorizontal":"styles_boxHorizontal__1MjIJ"};